import React, { useEffect, useState, useCallback } from "react";
import { useGetWithdrawDepositInvoicesQuery } from "../../../redux/api/modules/billingApi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CustomTable from "../../../shared/CustomTable";
import CustomPagination from "../../../shared/CustomPagination";
import { WithdrawDepositColumns } from "../../../constants/BillingConstants";
import { EditIcon, PrintIcon } from "../../../utils/TableActionIcons";
import BillingFilters from "../../../components/his/billing/BillingFilters";
import usePersistentBillingFilters from "../../../hooks/usePersistentBillingFilters";
import CheckPermission from "../../../hooks/CheckPermission";
import { useSelector } from 'react-redux';
import { hasBillingSearchFilters, omitBillingDatesForSkipInitialLoad, shouldSkipInitialBillingLoad } from '../../../utils/businessLevelAccess';

function WithdrawDepositList() {
  const authUser = useSelector(state => state?.auth?.user);
  const skipInitialBillingLoad = shouldSkipInitialBillingLoad(authUser);
  const [payload, setPayload, resetPayload, appliedPayload, applyFilters] = usePersistentBillingFilters('withdraw', { per_page: 20 });

  const {
    data,
    isLoading: queryLoading,
    isFetching: queryFetching,
    refetch
  } = useGetWithdrawDepositInvoicesQuery(appliedPayload, {
    skip: skipInitialBillingLoad && !hasBillingSearchFilters(appliedPayload)
  });

  const loading = queryLoading || queryFetching;
  const { hasPermission } = CheckPermission();
 const isHaveUpdateInvoicePermission = hasPermission('invoices', 'update');
  const [searchQuery, setSearchQuery] = useState(payload?.query || "");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchInitialData = () => {
    refetch();
  };

  

  const onPageChange = async (newPage, newRowsPerPage) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      page: newPage,
      per_page: newRowsPerPage,
    }));
  };

  const actionBodyTempelate = (rowData) => {
    return (
      <div className="flex gap-2">
        {
          isHaveUpdateInvoicePermission && (
            <EditIcon
              title={t("EditInvoice")}
              iconSize="20"
              onClick={() =>
                navigate(`/billing/edit-withdraw-invoice/${rowData?.invoice_number}`, {
                  state: {
                    invoiceData: rowData,
                    returnTo: "/billing",
                    previousState: { activeInvoiceTabIndex: 4 }
                  },
                })
              }
            />
          )
        }
      
        <PrintIcon
          title={t("PrintInvoice")}
          iconSize="20"
          onClick={() =>
            navigate(`/print-invoice/${rowData?.invoice_number}`, {
              state: {
                invoiceNumber: rowData?.invoice_number,
                withdraw: true,
                activeTabIndex: 4,
                activeChildTabIndex: 1
              },
            })
          }
        />
      </div>
    );
  };

  const withdrawActions = {
    header: t("Actions"),
    body: actionBodyTempelate,
  };

  const columnsData = [withdrawActions, ...WithdrawDepositColumns(t)];

  return (
    <div>
      <BillingFilters
        applyFilters={applyFilters}
        setSearchQuery={setSearchQuery}
        fetchInitialData={fetchInitialData}
        searchQuery={searchQuery}
        payloadData={payload}
        setPayloadData={setPayload}
        refetch={refetch}
        invoiceType="withdraw"
        resetFilters={() => {
          resetPayload();
          setSearchQuery("");
        }}
      />
      <div>
        <CustomTable
          isLoading={loading}
          data={data?.data || []}
          columns={columnsData}
        />
        {data?.data?.length > 0 && !loading && (
          <CustomPagination
            currentPage={data?.page || payload?.page || 1}
            rowsPerPage={data?.per_page || payload?.per_page || 20}
            totalRecords={data?.totalRecords}
            totalPages={data?.totalPages}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default WithdrawDepositList;
